// extracted by mini-css-extract-plugin
export var dot = "_qq-2";
export var wave = "_qq-0";
export var waveSmall = "_qq-1";